import type { TrackJs } from './window';

export const mockTrackJs: TrackJs = {
  addMetadata: (key: string, value: string) => undefined, // eslint-disable-line @typescript-eslint/no-unused-vars
  track: (...args: any) => {
    // eslint-disable-next-line no-console
    console.error(...args);
    return undefined;
  },
  configure: (config: any) => undefined, // eslint-disable-line @typescript-eslint/no-unused-vars
  console: {
    error: (...args: any) => {
      // eslint-disable-next-line no-console
      console.error(...args);
      return undefined;
    },
    info: (...args: any) => {
      // eslint-disable-next-line no-console
      console.info(...args);
      return undefined;
    },
    warn: (...args: any) => {
      // eslint-disable-next-line no-console
      console.warn(...args);
      return undefined;
    },
  },
};
